<template>
  <teleport to="body">
    <div class="overlay">
      <div class="content text-center">
        <div class="loader-spinner mb-3" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p v-if="message" class="loader-message fs-6">{{ message }}</p>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'FullScreenLoader',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.88);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.content {
  text-align: center;
}

/* Spinner rosa/cinza do tema QueMimo */
.loader-spinner {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 4px solid #e0e0e0;
  border-top-color: var(--event-primary, #e91e8c);
  animation: spin 0.75s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loader-message {
  color: #444444;
  font-weight: 500;
  margin-top: 0.25rem;
}
</style>
